/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1BankId200,
  GetApiV1BankId401,
  GetApiV1BankId404,
  GetApiV1BankId500,
  GetApiV1BankIdPathParams,
  GetApiV1BankIdQueryResponse,
} from "../../types/bankRegistroController/GetApiV1BankId.ts";
import { bankViewModelSchema } from "../bankViewModelSchema.ts";

export const getApiV1BankIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1BankIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1BankId200Schema = z.lazy(
  () => bankViewModelSchema,
) as unknown as ToZod<GetApiV1BankId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1BankId401Schema =
  z.any() as unknown as ToZod<GetApiV1BankId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1BankId404Schema =
  z.any() as unknown as ToZod<GetApiV1BankId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1BankId500Schema =
  z.any() as unknown as ToZod<GetApiV1BankId500>;

export const getApiV1BankIdQueryResponseSchema = z.lazy(
  () => getApiV1BankId200Schema,
) as unknown as ToZod<GetApiV1BankIdQueryResponse>;
